import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';

import { Page } from '@src/components/base';

function UnderDevelopment() {
  return (
    <Page >
      <Box sx={StyleSheet.underDev}>
        <Typography variant="h1">Page under development</Typography>
      </Box>
    </Page>
  );
}

const StyleSheet = {
  underDev: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
  },
};

UnderDevelopment.displayName = 'UnderDevelopment';
export default UnderDevelopment;
